const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor () {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawerShouldBeMoved) {
      window.setTimeout(
        () => {
          const moveToElement = this.moveToElement

          this.removeAttribute('data-module-drawers-move-me')

          moveToElement.appendChild(this)
        },
        parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0,
      )
    }
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)

    this.setVideoState(val)

    if (!val && this.hasAttribute('open')) {
      this.close()
    }
  }

  setVideoState (isOpen) {
    this.querySelectorAll('[data-drawer-el="video"]').forEach((videoEl) => {
      if (isOpen) {
        if (!videoEl.dataset.loaded) {
          videoEl.querySelectorAll('source[data-src]').forEach((sourceEl) => {
            sourceEl.src = sourceEl.dataset.src
          })
          videoEl.dataset.loaded = 'true'
          videoEl.load()
        }

        videoEl.play().catch(() => {})
      } else {
        videoEl.pause()
        videoEl.currentTime = 0
      }
    })
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return getElement(this.getAttribute('data-module-drawers-move-me'))
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

customElements.define('site-drawer', SiteDrawer, { extends: 'dialog' })
